















































import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const couponModule = namespace("coupon");

@Component({})
export default class ActivityList extends Vue {
  @couponModule.State("activityList") list!: Array<any>;

  name = "";
  activityId = "";
  pageNum = 0;
  pageSize = 10;
  pages = 0;
  loading = false;
  finished = false;
  mapState = ['待配置' , '进行中' , '暂停' , '已结束' ,'待启动' ,'已废弃' ,'待审核']
  typeList = ['primary','success','warning',undefined,'primary','danger','primary',]
  couponName:any= ''

  @Watch("$route", { immediate: true })
  private changeRouter(route: any) {
    console.log(123);
    this.$store.commit("coupon/clearActivityList");
    this.pageNum=0;
  }

  onLoad() {
    console.log(567);
    this.getActivityList(this.pageNum+1);
  }
  onSearch() {
      this.$store.commit('coupon/resetActivityList')
      this.getActivityList()
  }

  async getActivityList(pageNum: number = 1, pageSize: number = 10) {
    console.log(123123);
    const { error, success }: any = await this.$store.dispatch(
      "coupon/getActivityList",
      {
        activityName:this.name,
        pageNum,
        pageSize,
        upTenantId : this.$global.parentBusinessEntityId,
        upTenantType: this.$global.parentBusinessEntityTypeId
      }
    );
    if (success) {
      this.pageNum = success.data.pageNum;
      this.pages = success.data.pages;
      this.loading = false;
      if (success.data.pageNum == success.data.pages) {
        this.finished = true;
      }
    }
    if (error) {
      this.loading = false;
    }
  }

  async injection() {
    let activity = this.list.find(item => {
      return item.activityId == this.activityId;
    });
    const { error, success }: any = await this.$request(
      "COUPON_INJECTION",
      {
          couponId:this.$route.query.id,
          couponActivityId:this.activityId,
          couponActivityName:activity.activityName,
          couponActivityBusinessEntityId:this.$global.parentBusinessEntityId?this.$global.parentBusinessEntityId:this.$global.tenantId,
          couponActivityBusinessEntityTypeId:this.$global.parentBusinessEntityTypeId?this.$global.parentBusinessEntityTypeId:this.$global.tenantType,
          couponActivityBusinessEntityName:this.$global.tenantName,

      }
    );
    if (success) {
      this.$router.push("/coupon/list");
      (this as any).$notify({ type: 'success', message: '投放成功' });
    }
    if(error){
      this.$notify(error.msg);
    }

  }

  createHandler() {
    this.$router.push("/coupon/list");
  }

  mounted() {
    this.couponName = this.$route.query.name
    // this.getActivityList();
  }
}
